import React from 'react';
import { useSpring, animated } from 'react-spring';
import '../styles.css';
import StarIcon from '../../HOME/SVG/StarIcon';
import * as f from '../logic';

const Cell = ({ cell, index }) => {
  const { key } = cell;
  const { row, col } = f.cellPos(index);
  const gridArea = `${row}/${col}`;
  const background = key ? f.palette[key].background : 'initial';

  const { opacity } = useSpring({
    opacity: `${key ? 1 : 0}`,
  });

  return (
    <animated.div style={{ gridArea, background, display: 'grid', alignContent: 'center', justifyContent: 'center', opacity }}>
      <Star width="18" />
    </animated.div>
  );
};

export default Cell;

export const Star = ({ width }) => {
  const styles = { white: { gridArea: '1/1', zIndex: 1 }, black: { gridArea: '1/1', transform: 'translate(1px, 1px)' } };

  return (
    <>
      <StarIcon width={width} strokeWidth="3" style={styles.white} />
      <StarIcon width={width} stroke="black" strokeWidth="3" style={styles.black} />
    </>
  );
};
